import React from 'react';
import classnames from 'classnames';

type Props = {
  disabled?: boolean;
  minCents?: number;
  onSubmit: (priceCents: number) => void;
  onMount?: (clearHandler: () => void) => void;
};

export const BidInput: React.FC<Props> = React.forwardRef<HTMLInputElement, Props>(
  ({ onSubmit, onMount, disabled, minCents = 100 }, ref) => {
    const [dollars, setDollars] = React.useState(0);
    const dollarsFormatted = dollars === 0 ? '' : `${dollars}`;

    React.useEffect(() => {
      if (onMount) {
        onMount(() => {
          setDollars(0);
        });
      }
    }, []);

    return (
      <label
        className={classnames('bid-input mb-1', {
          'bid-input--disabled': disabled,
        })}
      >
        <span className='bid-input__currency'>$</span>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onSubmit(dollars * 100);
          }}
          className='d-flex w-100 mb-0'
        >
          <input
            ref={ref}
            className='input-blended bid-input__input'
            min={minCents / 100}
            max={1000000}
            type='number'
            value={dollarsFormatted}
            onChange={(event) => {
              setDollars(parseFloat(event.currentTarget.value));
            }}
            disabled={disabled}
            required
          />
          <button className='btn bid-input__button bg-black' type='submit' disabled={disabled}>
            Bid
          </button>
        </form>
      </label>
    );
  },
);
